/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as o}from"../../chunks/vec3f64.js";import{projectBuffer as r}from"./projectBuffer.js";function e(o,e,c,f=0){t[0]=o.x,t[1]=o.y;const n=o.z;return t[2]=void 0!==n?n:f,r(t,o.spatialReference,0,e,c,0,1)}const t=o();export{e as projectPointToVector};
